export { default as FeatureToggle } from './src/feature-toggle';
